export default __webpack_public_path__ + "static/media/mr.31660279.svg";